import styled from 'styled-components';

export const Wrapper = styled.div`
    width: calc((100% - 30px) / 2);
    transition: 0.2s;
    @media screen and (max-width: 767px){
        width: 100%;
    }
`;

export const ContentArea = styled.div`
    width: 100%;
    text-align: center;
    overflow: hidden;
`;

export const StyledImage = styled.img`
    width: 100%;
    height: 300px;
    display: block;
    object-fit: fill;
    opacity: ${({ $fade }) => ($fade ? 1 : 0)};
    transition: opacity 0.6s ease-in-out;
`;

export const PaginationWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 20px;
    background-color: #ffffff;
    gap: 20px;
`;

export const PageButton = styled.button`
    width: 28px;
    height: 36px;
    border: none;
    cursor: pointer;
    font-size: 100%;
    color: white;
    transition: all 0.3s ease;
    background-color: ${(props) => (props.active ? '#0275b1' : '#87BEE0')};
    opacity: ${(props) => (props.active ? 1 : 0.8)};
    &:hover {
        opacity: 1;
    }
`;
